import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=17b3c21e&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b3c21e",
  null
  
)

export default component.exports